import React, { Fragment, useState } from "react";
import {
  BackgroundDiv,
  BottomBtnArea,
  ContentBody,
  ContentBody2,
  HeaderTitle,
  NoticeText,
} from "./ReceiptStyle";

import { Button, Input, Layer } from "../../../components";
import { IC, ListIcon } from "../../../resources/Assets";
import CommonNoticeText from "../../common/NoticeText/CommonNoticeText";
import { maxLengthCheck } from "../../common/maxLengthCheck/maxLengthCheck";
import { checkData, telValidator } from "../../../modules/utils/CheckLogic";

const ReceiptPharm = props => {
  const {
    setPageIdx,
    pharmInfo,
    setPharmInfo,
    pharmInfoTemp,
    setPharmInfoTemp,
  } = props;

  const [phKey, setPhKey] = useState(
    defaultData("phKey", pharmInfo, pharmInfoTemp)
  );
  const [pharmName, setPharmName] = useState(
    defaultData("pharmName", pharmInfo, pharmInfoTemp)
  );
  const [pharmFaxNum, setPharmFaxNum] = useState(
    defaultData("pharmFaxNum", pharmInfo, pharmInfoTemp)
  );
  const [pharmTelNo, setPharmTelNo] = useState(
    defaultData("pharmTelNo", pharmInfo, pharmInfoTemp)
  );

  const [layerView, setLayerView] = useState(false);
  const [varidateLayerView, setVaridateLayerView] = useState(false);

  const [layerMsgType, setLayerMsgType] = useState("historyBack");

  const layerMsg = {
    historyBack: {
      headerIcon: "",
      title: "다른 페이지로 이동하시겠습니까?",
      desc: ["입력하신 정보는 저장되지 않습니다"],
      ps: "",
      psIcon: true,
      button: [
        {
          severity: "light",
          disable: "off",
          small: false,
          clickEvent: () => setLayerView(false),
          text: "아니오",
        },

        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setPageIdx(1);
            setPharmInfoTemp({
              phKey: phKey,
              pharmName: pharmName,
              pharmTelNo: pharmTelNo,
              pharmFaxNum: pharmFaxNum,
            });
            setPharmInfo(null);
          },
          text: "네",
        },
      ],
    },
    inputLater: {
      headerIcon: IC.etc.ICON_PILL,
      title: "약국정보를 나중에 입력하시겠습니까?",
      desc: [
        "홈화면이나 예약현황에서",
        <br />,
        <font color="#6B65DE">[약국정보 입력하기]</font>,
        "를 눌러 다시 입력할 수 있어요",
      ],
      ps: "병원에서 진료종료 후 바로 처방전을 전송하기 위해서는 약국정보가 필요합니다.",
      psIcon: true,
      button: [
        {
          severity: "light",
          disable: "off",
          small: false,
          clickEvent: () => {
            setLayerView(false);
            setLayerMsgType("historyBack");
          },
          text: "지금입력",
        },

        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setPageIdx(5);
            setPharmInfoTemp({
              phKey: phKey,
              pharmName: pharmName,
              pharmTelNo: pharmTelNo,
              pharmFaxNum: pharmFaxNum,
            });
            setPharmInfo(null);
          },
          text: "네",
        },
      ],
    },

    resetPharmData: {
      headerIcon: "",
      title: "약국정보 초기화",
      desc: ["입력된 약국 정보를 초기화하시겠습니까?"],
      ps: "",
      psIcon: false,
      button: [
        {
          severity: "light",
          disable: "off",
          small: false,
          clickEvent: () => setLayerView(false),
          text: "아니오",
        },

        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            resetPharmData();
            setLayerView(false);
          },
          text: "네",
        },
      ],
    },
  };

  const inputOnChange = (value, target) => {
    switch (target) {
      case "name": {
        setPharmName(value);
        break;
      }
      case "pharmTelNo": {
        setPharmTelNo(value);
        break;
      }

      case "pharmFaxNum": {
        setPharmFaxNum(value);
        break;
      }
    }
  };

  const returnDisable = target => {
    switch (target) {
      case "name": {
        if (phKey && (phKey || phKey != "")) {
          return true;
        } else {
          return false;
        }
      }

      case "tel": {
        if (pharmTelNo && pharmTelNo.length >= 9) {
          // 버튼 활성화
          return false;
        } else {
          // 버튼 비활성화
          return true;
        }
      }
    }
  };

  const callToPharm = () => {
    if (returnDisable("tel")) {
      return;
    } else {
      location.href = "tel:" + pharmTelNo;
    }
  };

  const checkSubmitData = () => {
    // pharmName, pharmTelNo, pharmFaxNum
    if (
      pharmName &&
      pharmName.trim().length > 1 &&
      pharmTelNo &&
      pharmTelNo.trim().length > 8 &&
      pharmFaxNum &&
      pharmFaxNum.trim().length > 8
    ) {
      return true;
    } else {
      return false;
    }
  };

  const submit = () => {
    if (
      pharmName &&
      pharmName != "" &&
      pharmTelNo &&
      pharmTelNo != "" &&
      pharmFaxNum &&
      pharmFaxNum != "" &&
      checkData("storeName", pharmName.trim()) &&
      checkData("number", pharmTelNo.trim()) &&
      checkData("faxNum", pharmFaxNum.trim())
    ) {
      setPharmInfo({
        phKey: phKey,
        pharmName: pharmName,
        pharmTelNo: pharmTelNo,
        pharmFaxNum: pharmFaxNum,
      });
      setPageIdx(5);
    } else {
      setVaridateLayerView(true);
    }

    // if (checkSubmitData()) {
    //   // if (telValidator(pharmTelNo)) {
    //   if (
    //     checkData("korEngNum", pharmName.trim()) &&
    //     checkData("number", pharmTelNo.trim()) &&
    //     checkData("faxNum", pharmFaxNum.trim())
    //   ) {
    //     setPharmInfo({
    //       phKey: phKey,
    //       pharmName: pharmName,
    //       pharmTelNo: pharmTelNo,
    //       pharmFaxNum: pharmFaxNum,
    //     });
    //     setPageIdx(1);
    //   } else {
    //     setVaridateLayerView(true);
    //   }
    // } else {
    //   setLayerView(true);
    // }
  };

  const checkErrTarget = () => {
    if (
      !pharmName ||
      pharmName === "undefined" ||
      pharmName.trim().length === 0 ||
      pharmName.trim().length < 2 ||
      checkData("storeName", pharmName) == false
    ) {
      return "약국명을";
    } else if (
      !pharmTelNo ||
      pharmTelNo === "undefined" ||
      pharmTelNo.trim().length < 9 ||
      checkData("number", pharmTelNo.trim()) == false
    ) {
      return "전화번호를";
    } else if (
      !pharmFaxNum ||
      pharmFaxNum === "undefined" ||
      pharmFaxNum.trim().length < 9 ||
      checkData("faxNum", pharmFaxNum.trim()) == false
    ) {
      return "팩스번호를";
    }

    return "문제없음";
  };

  const resetPharmData = () => {
    setPhKey("");
    setPharmName("");
    setPharmTelNo("");
    setPharmFaxNum("");
  };

  return (
    <Fragment>
      <BackgroundDiv>
        <HeaderTitle>
          <div
            style={{ width: "40px", height: "40px" }}
            onClick={() =>
              pharmInfo ? props.setPageIdx(1) : setLayerView(true)
            }>
            <img src={IC.etc.ICON_CHEVRON_LEFT} />
          </div>
          {/* <div>약국정보</div> */}
          <div>{props.hederTitle}</div>
          <div style={{ width: "40px", height: "40px" }}>
            {/* <img src={ArrowLeft} /> */}
          </div>
        </HeaderTitle>
        <ContentBody>
          <NoticeText>
            처방약을 받을 약국정보를
            <br />
            미리 입력해주세요
          </NoticeText>

          <ContentBody2>
            <CommonNoticeText
              psIcon={true}
              title="병원에서 진료종료 후 바로 처방전을 전송하기 위해서는 약국정보가 필요합니다."
              text=""
            />

            <Button
              severity="light"
              disable="off"
              R_ICON={ListIcon.RECEIPT.R_ICON.SEARCH}
              clickEvent={() => setPageIdx(8)}>
              약국 검색
            </Button>

            <Input
              title_view={true}
              title="약국명"
              input_view={true}
              input_type="text"
              input_pattern=""
              input_disable={returnDisable("name")}
              input_placeholder="약국명을 입력하세요"
              // input_defaultValue={pharmInfo ? pharmInfo.pharmName.trim() : ""}
              input_defaultValue={pharmName ? pharmName.trim() : ""}
              input_onChange={e => {
                maxLengthCheck(20, e);
                inputOnChange(e.target.value, "name");
              }}
              button_view={true}
              button_severity="secondary"
              button_disable={"off"}
              button_small={true}
              button_event={() => {
                setLayerMsgType("resetPharmData");
                setLayerView(true);
              }}
              button_text="초기화"
              button_style={{ flex: "0.25 0 0" }}
            />

            <Input
              title_view={true}
              title="전화번호"
              input_view={true}
              input_type="number"
              input_pattern="\d*"
              input_disable={false}
              input_placeholder="약국 전화번호를 입력하세요"
              input_defaultValue={pharmTelNo ? pharmTelNo.trim() : ""}
              input_onChange={e => {
                maxLengthCheck(12, e);
                inputOnChange(e.target.value, "pharmTelNo");
              }}
              input_maxLength="11"
              button_view={true}
              button_severity="secondary"
              button_disable={returnDisable("tel") ? "on" : "off"}
              button_small={true}
              button_event={() => callToPharm()}
              button_text="전화연결"
              button_style={{ flex: "0.25 0 0" }}
            />

            <Input
              title_view={true}
              title="팩스번호"
              input_view={true}
              input_type="number"
              input_pattern="\d*"
              input_disable={false}
              input_placeholder="약국 팩스번호를 입력하세요"
              input_defaultValue={pharmFaxNum ? pharmFaxNum.trim() : ""}
              input_onChange={e => {
                maxLengthCheck(12, e);
                inputOnChange(e.target.value, "pharmFaxNum");
              }}
              button_view={false}
            />
          </ContentBody2>
        </ContentBody>

        <BottomBtnArea
          style={{ display: "flex", flexFlow: "column", gap: "8px" }}>
          <Button
            // severity="primary_light"
            severity={"primary_light"}
            // disable={checkSubmitData() ? "off" : "on"}
            disable={"off"}
            clickEvent={() => {
              setLayerMsgType("inputLater");
              setLayerView(true);
            }}>
            {"나중에 입력"}
          </Button>
          <Button
            // severity="primary_light"
            severity={"primary"}
            // disable={checkSubmitData() ? "off" : "on"}
            disable={"off"}
            clickEvent={() => submit()}>
            {"저장 후 다음"}
          </Button>
        </BottomBtnArea>
      </BackgroundDiv>

      {layerView && (
        <Layer
          headerIcon={layerMsg[layerMsgType].headerIcon}
          title={layerMsg[layerMsgType].title}
          desc={layerMsg[layerMsgType].desc}
          ps={layerMsg[layerMsgType].ps}
          psIcon={layerMsg[layerMsgType].psIcon}
          button={layerMsg[layerMsgType].button}
        />
      )}

      {varidateLayerView && (
        <Layer
          title={checkErrTarget() + " 입력해주세요"}
          desc={[checkErrTarget() + " 입력하시고 다시 시도해주세요"]}
          ps=""
          psIcon={false}
          button={[
            {
              severity: "primary",
              disable: "off",
              small: false,
              clickEvent: () => {
                setVaridateLayerView(false);
              },
              text: "확인",
            },
          ]}
        />
      )}
    </Fragment>
  );
};

const defaultData = (target, pharmInfo, pharmInfoTemp) => {
  switch (target) {
    case "phKey": {
      return pharmInfo && pharmInfo.phKey != ""
        ? pharmInfo.phKey
        : pharmInfoTemp && pharmInfoTemp.phKey != ""
        ? pharmInfoTemp.phKey
        : null;
    }
    case "pharmName": {
      return pharmInfo && pharmInfo.pharmName != ""
        ? pharmInfo.pharmName
        : pharmInfoTemp && pharmInfoTemp.pharmName != ""
        ? pharmInfoTemp.pharmName
        : null;
    }
    case "pharmFaxNum": {
      return pharmInfo && pharmInfo.pharmFaxNum != ""
        ? pharmInfo.pharmFaxNum
        : pharmInfoTemp && pharmInfoTemp.pharmFaxNum != ""
        ? pharmInfoTemp.pharmFaxNum
        : null;
    }
    case "pharmTelNo": {
      return pharmInfo && pharmInfo.pharmTelNo != ""
        ? pharmInfo.pharmTelNo
        : pharmInfoTemp && pharmInfoTemp.pharmTelNo != ""
        ? pharmInfoTemp.pharmTelNo
        : null;
    }
  }
};

export default ReceiptPharm;
